var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":function($event){return _vm.$emit('clicked', $event)}}},[_vm._t("left-icon"),_vm._t("pill-text",[_vm._v(_vm._s(_vm.pillText))]),_vm._t("right-icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }